import { appUrl } from 'utils/wrappers';

import Base from 'app/models/base';

const User = Base.extend({
  urlRoot: appUrl('users'),
  rootKey: 'user',

  fetch() {
    Base.prototype.fetch.call(this, { data: { includes: ['vendor'] } });
  },

  parse(attrs) {
    const childModels = [];
    const acl = attrs.acl || {};
    if (attrs.children) {
      attrs.children.forEach(childRaw => childModels.push(new User(childRaw)));
    }
    // add ACLs direct from vendor response for fulfillment
    if (attrs.vendor && attrs.vendor.id) {
      acl.fulfillment = true;
      if (attrs.vendor.third_party_stores && attrs.vendor.third_party_stores.length) {
        acl.thirdparty_fulfillment = true;
      }
    }
    return {
      ...attrs,
      children: childModels,
      acl,
    };
  },

  isLoggedIn() {
    return !!this.id && this.get('verified');
  },
  isLoggedInAllowUnverified() {
    return !!this.id;
  },
});

export default User;



// WEBPACK FOOTER //
// ./app/models/user.js